function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "12",
  viewBox: "0 0 80 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.634 15C2.371 15 0 12.533 0 7.489 0 2.467 2.35 0 6.634 0h4.024v2.622H6.634c-2.85 0-4.067 1.445-4.067 4.867 0 3.444 1.24 4.889 4.067 4.889h8.43V15h-8.43zM22.412 0l4.835 13.1c.534 1.441 1.625 1.9 3.037 1.9 1.498 0 2.482-.524 3.017-1.9L38.39 0H35.59l-4.6 11.856c-.15.35-.363.502-.706.502-.342 0-.577-.153-.706-.502L25.193 0h-2.781zM53.099 3.144c.15-.35.385-.502.727-.502.343 0 .578.153.706.502L58.918 15h2.802L56.843 1.9C56.328.524 55.345 0 53.848 0c-1.52 0-2.503.524-3.038 1.9L45.74 15h2.781l4.578-11.856zM69.068 0v2.567h4.198V15h2.536V2.566H80V0H69.068z",
  fill: "#fff"
})));